<template lang="html">
  <div class="cancelReason">
    <div class="item-cells">
      <div
        class="item-cell"
        v-for="(reason, index) in reasons"
        :class="{ active: index === checked }"
        @click="chooseReason(index, reason)"
      >
        <div class="item-cell-bd">{{ reason }}</div>
      </div>
    </div>
    <div class="actions">
      <button @click="confirmCancel">确认</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {},
  data() {
    return {
      checked: -1,
      reason: ''
    }
  },
  computed: {
    ...mapState(['order', 'reasons'])
  },
  methods: {
    chooseReason(i, reason) {
      this.checked = i
      this.reason = reason
      // 埋点
    },
    async confirmCancel() {
      if (this.reason === '') {
        this.$$toast('请选择取消原因')
        return
      }
      const { uid, skey } = await this.$$ensureLogin()
      const res = await this.$store.dispatch('cancelOrder', {
        uid,
        skey,
        vorder_id: this.order.orderId,
        cancel_reason: this.reason
      })
      if (res.code === '1') {
        // this.order.state = 5;
        // this.order.cancel_reason = this.reason
        // this.order.cancel_time = (new Date() - 0) / 1000
        // this.$store.commit('setOrder', {
        //     ...this.order,
        //     ...{
        //         state: 50,
        //         cancel_reason: this.reason,
        //         cancel_time: (new Date() - 0) / 1000
        //     }
        // })
        await this.$store.dispatch('getOrderDetail', {
          uid: this.$$cookie('uid'),
          skey: this.$$cookie('skey'),
          orderCode: this.order.orderId
        })
        this.$$toast('取消成功')
        this.$store.commit('hideActionSheet')
      } else if (res.code === '4') {
        this.$$login()
      } else {
        this.$$toast('取消失败')
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.cancelReason {
  height: 100%;
  // position: relative;
  .selected {
    // color: #ff397e;
    color: #ff5900;
  }
  .item-cells {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: rem(100px);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .actions {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;

    button {
      display: block;
      width: 100%;
      text-align: center;
      line-height: rem(98px);
      color: #fff;
      font-size: rem(36px);
      // background: #ff397e;
      background: #ff5900;
    }
  }
  .active {
    // color: #ff397e;
    color: #ff5900;
  }
}
</style>
